import { useState, useEffect, useCallback } from "react";
import config from '../config';

// Tema konfigürasyonu - Tüm renk ayarları tek yerde
const THEME_CONFIG = {
  general: {
    backgroundColor: {
      key: "appBackgroundColor",
      cssVar: "--app-background-color",
      default: "#080d19",
      label: "Arka Plan Rengi",
    },
  },
  header: {
    titleColor: {
      key: "headerTitleColor",
      cssVar: "--header-title-color",
      default: "#ffffff",
      label: "Başlık Rengi",
    },
    usernameColor: {
      key: "headerUsernameColor",
      cssVar: "--header-username-color",
      default: "#0ea5e9",
      label: "Kullanıcı Adı Rengi",
    },
    subtitleColor: {
      key: "headerSubtitleColor",
      cssVar: "--header-subtitle-color",
      default: "rgba(255, 255, 255, 0.50)",
      label: "Alt Başlık Rengi",
    },
    iconColor: {
      key: "headerIconColor",
      cssVar: "--header-icon-color",
      default: "#ffffff",
      label: "İkon Rengi",
    },
    iconBgColor: {
      key: "headerIconBgColor",
      cssVar: "--header-icon-bg-color",
      default: "rgba(255, 255, 255, 0.08)",
      label: "İkon Arka Plan Rengi",
    },
    logoMaxWidth: {
      key: "headerLogoMaxWidth",
      cssVar: "--logo-max-width",
      default: "260",
      label: "Logo Genişliği",
      type: "range",
      min: 60,
      max: 500,
      step: 5,
      unit: "px",
    },
    logoPaddingTop: {
      key: "headerLogoPaddingTop",
      cssVar: "--logo-padding-top",
      default: "0",
      label: "Logo Üst Boşluk",
      type: "range",
      min: 0,
      max: 80,
      step: 1,
      unit: "px",
    },
    logoPaddingBottom: {
      key: "headerLogoPaddingBottom",
      cssVar: "--logo-padding-bottom",
      default: "0",
      label: "Logo Alt Boşluk",
      type: "range",
      min: 0,
      max: 80,
      step: 1,
      unit: "px",
    },
    logoMarginTop: {
      key: "headerLogoMarginTop",
      cssVar: "--logo-margin-top",
      default: "0",
      label: "Logo Üst Margin",
      type: "range",
      min: -40,
      max: 80,
      step: 1,
      unit: "px",
    },
    logoMarginBottom: {
      key: "headerLogoMarginBottom",
      cssVar: "--logo-margin-bottom",
      default: "0",
      label: "Logo Alt Margin",
      type: "range",
      min: -40,
      max: 80,
      step: 1,
      unit: "px",
    },
  },
  mainCategory: {
    bgColor: {
      key: "mainCategoryBgColor",
      cssVar: "--main-category-bg-color",
      default: "rgba(255, 255, 255, 0.06)",
      label: "Arka Plan Rengi",
    },
    borderColor: {
      key: "mainCategoryBorderColor",
      cssVar: "--main-category-border-color",
      default: "rgba(14, 165, 233, 0.22)",
      label: "Kenarlık Rengi",
    },
    textColor: {
      key: "mainCategoryTextColor",
      cssVar: "--main-category-text-color",
      default: "#ffffff",
      label: "Yazı Rengi",
    },
    iconColor: {
      key: "mainCategoryIconColor",
      cssVar: "--main-category-icon-color",
      default: "#ffffff",
      label: "İkon Çizim Rengi",
    },
    iconBgColor: {
      key: "mainCategoryIconBgColor",
      cssVar: "--main-category-icon-bg-color",
      default: "transparent",
      label: "İkon Arka Plan Rengi",
    },
    iconHoverBgColor: {
      key: "mainCategoryIconHoverBgColor",
      cssVar: "--main-category-icon-hover-bg-color",
      default: "transparent",
      label: "İkon Hover Arka Plan",
    },
    hoverBgColor: {
      key: "mainCategoryHoverBgColor",
      cssVar: "--main-category-hover-bg-color",
      default: "rgba(14, 165, 233, 0.16)",
      label: "Hover Arka Plan Rengi",
    },
    hoverBorderColor: {
      key: "mainCategoryHoverBorderColor",
      cssVar: "--main-category-hover-border-color",
      default: "rgba(14, 165, 233, 0.38)",
      label: "Hover Kenarlık Rengi",
    },
    hoverTextColor: {
      key: "mainCategoryHoverTextColor",
      cssVar: "--main-category-hover-text-color",
      default: "#ffffff",
      label: "Hover Yazı Rengi",
    },
    activeBgColor: {
      key: "mainCategoryActiveBgColor",
      cssVar: "--main-category-active-bg-color",
      default: "#0ea5e9",
      label: "Aktif Arka Plan Rengi",
    },
    activeBorderColor: {
      key: "mainCategoryActiveBorderColor",
      cssVar: "--main-category-active-border-color",
      default: "rgba(14, 165, 233, 0.50)",
      label: "Aktif Kenarlık Rengi",
    },
    activeTextColor: {
      key: "mainCategoryActiveTextColor",
      cssVar: "--main-category-active-text-color",
      default: "#ffffff",
      label: "Aktif Yazı Rengi",
    },
    activeIconColor: {
      key: "mainCategoryActiveIconColor",
      cssVar: "--main-category-active-icon-color",
      default: "#ffffff",
      label: "Aktif İkon Çizim Rengi",
    },
    activeIconBgColor: {
      key: "mainCategoryActiveIconBgColor",
      cssVar: "--main-category-active-icon-bg-color",
      default: "transparent",
      label: "Aktif İkon Arka Plan",
    },
    activeGlowColor: {
      key: "mainCategoryActiveGlowColor",
      cssVar: "--main-category-active-glow-color",
      default: "rgba(14, 165, 233, 0.40)",
      label: "Aktif Parıltı Rengi",
    },
  },
  tab: {
    bgColor: {
      key: "tabBgColor",
      cssVar: "--tab-bg-color",
      default: "rgba(255, 255, 255, 0.06)",
      label: "Arka Plan Rengi",
    },
    borderColor: {
      key: "tabBorderColor",
      cssVar: "--tab-border-color",
      default: "rgba(255, 255, 255, 0.08)",
      label: "Kenarlık Rengi",
    },
    textColor: {
      key: "tabTextColor",
      cssVar: "--tab-text-color",
      default: "#ffffff",
      label: "Yazı Rengi",
    },
    iconColor: {
      key: "tabIconColor",
      cssVar: "--tab-icon-color",
      default: "rgba(255, 255, 255, 0.75)",
      label: "İkon Rengi",
    },
    hoverBgColor: {
      key: "tabHoverBgColor",
      cssVar: "--tab-hover-bg-color",
      default: "rgba(255, 255, 255, 0.07)",
      label: "Hover Arka Plan Rengi",
    },
    hoverBorderColor: {
      key: "tabHoverBorderColor",
      cssVar: "--tab-hover-border-color",
      default: "rgba(255, 255, 255, 0.14)",
      label: "Hover Kenarlık Rengi",
    },
    hoverTextColor: {
      key: "tabHoverTextColor",
      cssVar: "--tab-hover-text-color",
      default: "#ffffff",
      label: "Hover Yazı Rengi",
    },
    activeBgColor: {
      key: "tabActiveBgColor",
      cssVar: "--tab-active-bg-color",
      default: "#0ea5e9",
      label: "Aktif Arka Plan Rengi",
    },
    activeBorderColor: {
      key: "tabActiveBorderColor",
      cssVar: "--tab-active-border-color",
      default: "transparent",
      label: "Aktif Kenarlık Rengi",
    },
    activeTextColor: {
      key: "tabActiveTextColor",
      cssVar: "--tab-active-text-color",
      default: "#ffffff",
      label: "Aktif Yazı Rengi",
    },
    activeIconColor: {
      key: "tabActiveIconColor",
      cssVar: "--tab-active-icon-color",
      default: "#ffffff",
      label: "Aktif İkon Rengi",
    },
    activeGlowColor: {
      key: "tabActiveGlowColor",
      cssVar: "--tab-active-glow-color",
      default: "rgba(14, 165, 233, 0.40)",
      label: "Aktif Parıltı Rengi",
    },
    goldMode: {
      key: "tabGoldMode",
      cssVar: "--tab-gold-mode",
      default: "false",
      label: "Altın Görünüm (Gold)",
      type: "boolean",
    },
  },
  bonusCard: {
    bgColor: {
      key: "bonusCardBgColor",
      cssVar: "--bonus-card-bg-color",
      default: "rgba(255, 255, 255, 0.04)",
      label: "Kart Arka Plan Rengi",
    },
    borderColor: {
      key: "bonusCardBorderColor",
      cssVar: "--bonus-card-border-color",
      default: "rgba(255, 255, 255, 0.09)",
      label: "Kart Kenarlık Rengi",
    },
    color: {
      key: "bonusCardColor",
      cssVar: "--bonus-card-color",
      default: "rgba(14, 165, 233, 0.50)",
      label: "Kart Parıltı Rengi",
    },
    brightness: {
      type: "range",
      key: "bonusCardBrightness",
      cssVar: "--bonus-card-brightness",
      default: "1",
      label: "Görsel Parlaklık",
      min: 0.3,
      max: 1.5,
      step: 0.05,
    },
  },
  bonusBadges: {
    casinoBadgeBg: {
      key: "bonusBadgeCasinoBg",
      cssVar: "--badge-casino-bg",
      default: "#1d4ed8",
      label: "Casino - Arka Plan",
    },
    casinoBadgeText: {
      key: "bonusBadgeCasinoText",
      cssVar: "--badge-casino-text",
      default: "#ffffff",
      label: "Casino - Yazı Rengi",
    },
    sporBadgeBg: {
      key: "bonusBadgeSporBg",
      cssVar: "--badge-spor-bg",
      default: "#15803d",
      label: "Spor - Arka Plan",
    },
    sporBadgeText: {
      key: "bonusBadgeSporText",
      cssVar: "--badge-spor-text",
      default: "#ffffff",
      label: "Spor - Yazı Rengi",
    },
    kayipBadgeBg: {
      key: "bonusBadgeKayipBg",
      cssVar: "--badge-kayip-bg",
      default: "#b91c1c",
      label: "Kayıp - Arka Plan",
    },
    kayipBadgeText: {
      key: "bonusBadgeKayipText",
      cssVar: "--badge-kayip-text",
      default: "#ffffff",
      label: "Kayıp - Yazı Rengi",
    },
    hosgeldinBadgeBg: {
      key: "bonusBadgeHosgeldinBg",
      cssVar: "--badge-hosgeldin-bg",
      default: "#7c3aed",
      label: "Hoşgeldin - Arka Plan",
    },
    hosgeldinBadgeText: {
      key: "bonusBadgeHosgeldinText",
      cssVar: "--badge-hosgeldin-text",
      default: "#ffffff",
      label: "Hoşgeldin - Yazı Rengi",
    },
    denemeBadgeBg: {
      key: "bonusBadgeDenemeBg",
      cssVar: "--badge-deneme-bg",
      default: "#0e7490",
      label: "Deneme - Arka Plan",
    },
    denemeBadgeText: {
      key: "bonusBadgeDenemeText",
      cssVar: "--badge-deneme-text",
      default: "#ffffff",
      label: "Deneme - Yazı Rengi",
    },
    carkBadgeBg: {
      key: "bonusBadgeCarkBg",
      cssVar: "--badge-cark-bg",
      default: "#d97706",
      label: "Çark - Arka Plan",
    },
    carkBadgeText: {
      key: "bonusBadgeCarkText",
      cssVar: "--badge-cark-text",
      default: "#ffffff",
      label: "Çark - Yazı Rengi",
    },
    haftalikBadgeBg: {
      key: "bonusBadgeHaftalikBg",
      cssVar: "--badge-haftalik-bg",
      default: "#0f766e",
      label: "Haftalık - Arka Plan",
    },
    haftalikBadgeText: {
      key: "bonusBadgeHaftalikText",
      cssVar: "--badge-haftalik-text",
      default: "#ffffff",
      label: "Haftalık - Yazı Rengi",
    },
    yatirimBadgeBg: {
      key: "bonusBadgeYatirimBg",
      cssVar: "--badge-yatirim-bg",
      default: "#1d7b3b",
      label: "Yatırım - Arka Plan",
    },
    yatirimBadgeText: {
      key: "bonusBadgeYatirimText",
      cssVar: "--badge-yatirim-text",
      default: "#ffffff",
      label: "Yatırım - Yazı Rengi",
    },
    defaultBadgeBg: {
      key: "bonusBadgeDefaultBg",
      cssVar: "--badge-default-bg",
      default: "#374151",
      label: "Varsayılan - Arka Plan",
    },
    defaultBadgeText: {
      key: "bonusBadgeDefaultText",
      cssVar: "--badge-default-text",
      default: "#ffffff",
      label: "Varsayılan - Yazı Rengi",
    },
  },
  bonusButtons: {
    actionBarBgColor: {
      key: "bonusActionBarBgColor",
      cssVar: "--bonus-card-action-bar-bg-color",
      default: "rgba(6, 9, 20, 0.80)",
      label: "Talep Et - Arka Plan",
    },
    actionBarTextColor: {
      key: "bonusActionBarTextColor",
      cssVar: "--bonus-card-action-bar-text-color",
      default: "rgba(255, 255, 255, 0.90)",
      label: "Talep Et - Yazı Rengi",
    },
    actionBarHoverBgColor: {
      key: "bonusActionBarHoverBgColor",
      cssVar: "--bonus-card-action-bar-hover-bg-color",
      default: "rgba(14, 165, 233, 0.22)",
      label: "Talep Et - Hover Arka Plan",
    },
    actionBarHoverTextColor: {
      key: "bonusActionBarHoverTextColor",
      cssVar: "--bonus-card-action-bar-hover-text-color",
      default: "#ffffff",
      label: "Talep Et - Hover Yazı",
    },
    rulesBtnBgColor: {
      key: "bonusRulesBtnBgColor",
      cssVar: "--bonus-card-rules-btn-bg-color",
      default: "rgba(8, 16, 28, 0.75)",
      label: "Kurallar İkonu - Arka Plan",
    },
    rulesBtnColor: {
      key: "bonusRulesBtnColor",
      cssVar: "--bonus-card-rules-btn-color",
      default: "rgba(255, 255, 255, 0.7)",
      label: "Kurallar İkonu - Renk",
    },
    goldMode: {
      key: "bonusActionBarGoldMode",
      cssVar: "--bonus-card-gold-mode",
      default: "true",
      label: "Altın Görünüm (Gold)",
      type: "boolean",
    },
  },
  rulesPopup: {
    backgroundColor: {
      key: "rulesPopupBgColor",
      cssVar: "--rules-popup-bg-color",
      default: "rgba(14, 165, 233, 0.08)",
      label: "Popup Arka Plan Rengi",
    },
    borderColor: {
      key: "rulesPopupBorderColor",
      cssVar: "--rules-popup-border-color",
      default: "rgba(14, 165, 233, 0.20)",
      label: "Popup Kenarlık Rengi",
    },
    titleColor: {
      key: "rulesPopupTitleColor",
      cssVar: "--rules-popup-title-color",
      default: "#ffffff",
      label: "Bonus Başlık Rengi",
    },
    badgeBgColor: {
      key: "rulesPopupBadgeBgColor",
      cssVar: "--rules-popup-badge-bg-color",
      default: "rgba(14, 165, 233, 0.15)",
      label: "Rozet Arka Plan",
    },
    badgeBorderColor: {
      key: "rulesPopupBadgeBorderColor",
      cssVar: "--rules-popup-badge-border-color",
      default: "rgba(14, 165, 233, 0.28)",
      label: "Rozet Kenarlık",
    },
    badgeTextColor: {
      key: "rulesPopupBadgeTextColor",
      cssVar: "--rules-popup-badge-text-color",
      default: "#0ea5e9",
      label: "Rozet Yazı Rengi",
    },
    ruleBgColor: {
      key: "rulesPopupRuleBgColor",
      cssVar: "--rules-popup-rule-bg-color",
      default: "rgba(14, 165, 233, 0.07)",
      label: "Kural İçerik Arka Plan",
    },
    ruleBorderColor: {
      key: "rulesPopupRuleBorderColor",
      cssVar: "--rules-popup-rule-border-color",
      default: "rgba(14, 165, 233, 0.15)",
      label: "Kural Kenarlık Rengi",
    },
    ruleAccentColor: {
      key: "rulesPopupRuleAccentColor",
      cssVar: "--rules-popup-rule-accent-color",
      default: "#0ea5e9",
      label: "Kural Vurgu Rengi",
    },
    ruleTitleColor: {
      key: "rulesPopupRuleTitleColor",
      cssVar: "--rules-popup-rule-title-color",
      default: "#ffffff",
      label: "Kural Başlık Rengi",
    },
    ruleTextColor: {
      key: "rulesPopupRuleTextColor",
      cssVar: "--rules-popup-rule-text-color",
      default: "rgba(255, 255, 255, 0.60)",
      label: "Kural Metin Rengi",
    },
    understoodBgColor: {
      key: "rulesPopupUnderstoodBgColor",
      cssVar: "--rules-popup-understood-bg-color",
      default: "rgba(255, 255, 255, 0.07)",
      label: "Anladım Buton Arka Plan",
    },
    understoodTextColor: {
      key: "rulesPopupUnderstoodTextColor",
      cssVar: "--rules-popup-understood-text-color",
      default: "rgba(255, 255, 255, 0.75)",
      label: "Anladım Buton Yazı",
    },
    requestBgColor: {
      key: "rulesPopupRequestBgColor",
      cssVar: "--rules-popup-request-bg-color",
      default: "rgba(255, 255, 255, 0.09)",
      label: "Talep Et Buton Arka Plan",
    },
    requestTextColor: {
      key: "rulesPopupRequestTextColor",
      cssVar: "--rules-popup-request-text-color",
      default: "#ffffff",
      label: "Talep Et Buton Yazı",
    },
  },
  historyPopup: {
    backgroundColor: {
      key: "historyPopupBgColor",
      cssVar: "--history-popup-bg-color",
      default: "rgba(14, 165, 233, 0.08)",
      label: "Popup Arka Plan Rengi",
    },
    borderColor: {
      key: "historyPopupBorderColor",
      cssVar: "--history-popup-border-color",
      default: "rgba(14, 165, 233, 0.20)",
      label: "Popup Kenarlık Rengi",
    },
    iconColor: {
      key: "historyPopupIconColor",
      cssVar: "--history-popup-icon-color",
      default: "#0ea5e9",
      label: "Saat İkonu Rengi",
    },
    iconBgColor: {
      key: "historyPopupIconBgColor",
      cssVar: "--history-popup-icon-bg-color",
      default: "rgba(14, 165, 233, 0.09)",
      label: "Saat İkonu Arka Plan",
    },
    iconBorderColor: {
      key: "historyPopupIconBorderColor",
      cssVar: "--history-popup-icon-border-color",
      default: "rgba(14, 165, 233, 0.18)",
      label: "Saat İkonu Kenarlık",
    },
    headerTitleColor: {
      key: "historyPopupHeaderTitleColor",
      cssVar: "--history-popup-header-title-color",
      default: "#ffffff",
      label: "Başlık Rengi",
    },
    headerSubtitleColor: {
      key: "historyPopupHeaderSubtitleColor",
      cssVar: "--history-popup-header-subtitle-color",
      default: "rgba(255, 255, 255, 0.35)",
      label: "Alt Başlık Rengi",
    },
    closeIconBgColor: {
      key: "historyPopupCloseIconBgColor",
      cssVar: "--history-popup-close-icon-bg-color",
      default: "rgba(255, 255, 255, 0.07)",
      label: "Çarpı İkonu Arka Plan",
    },
    closeIconColor: {
      key: "historyPopupCloseIconColor",
      cssVar: "--history-popup-close-icon-color",
      default: "rgba(255, 255, 255, 0.50)",
      label: "Çarpı İkonu Rengi",
    },
    itemBgColor: {
      key: "historyPopupItemBgColor",
      cssVar: "--history-popup-item-bg-color",
      default: "rgba(14, 165, 233, 0.07)",
      label: "Öğe Arka Plan Rengi",
    },
    itemBorderColor: {
      key: "historyPopupItemBorderColor",
      cssVar: "--history-popup-item-border-color",
      default: "rgba(14, 165, 233, 0.14)",
      label: "Öğe Kenarlık Rengi",
    },
    itemTitleColor: {
      key: "historyPopupItemTitleColor",
      cssVar: "--history-popup-item-title-color",
      default: "#ffffff",
      label: "Öğe Başlık Rengi",
    },
    itemTimeColor: {
      key: "historyPopupItemTimeColor",
      cssVar: "--history-popup-item-time-color",
      default: "rgba(255, 255, 255, 0.32)",
      label: "Öğe Saat Rengi",
    },
    successColor: {
      key: "historyPopupSuccessColor",
      cssVar: "--history-popup-success-color",
      default: "#4ade80",
      label: "Onaylandı Rengi",
    },
    errorColor: {
      key: "historyPopupErrorColor",
      cssVar: "--history-popup-error-color",
      default: "#f87171",
      label: "Reddedildi Rengi",
    },
    footerBtnBgColor: {
      key: "historyPopupFooterBtnBgColor",
      cssVar: "--history-popup-footer-btn-bg-color",
      default: "rgba(255, 255, 255, 0.07)",
      label: "Kapat Buton Arka Plan",
    },
    footerBtnTextColor: {
      key: "historyPopupFooterBtnTextColor",
      cssVar: "--history-popup-footer-btn-text-color",
      default: "rgba(255, 255, 255, 0.75)",
      label: "Kapat Buton Yazı Rengi",
    },
  },
  multipleBonusDialog: {
    backgroundColor: {
      key: "multipleBonusDialogBgColor",
      cssVar: "--multiple-bonus-dialog-bg-color",
      default: "rgba(14, 165, 233, 0.08)",
      label: "Dialog Arka Plan Rengi",
    },
    headerTitleColor: {
      key: "multipleBonusDialogHeaderTitleColor",
      cssVar: "--multiple-bonus-dialog-header-title-color",
      default: "#ffffff",
      label: "Başlık Rengi",
    },
    headerSubtitleColor: {
      key: "multipleBonusDialogHeaderSubtitleColor",
      cssVar: "--multiple-bonus-dialog-header-subtitle-color",
      default: "rgba(255, 255, 255, 0.55)",
      label: "Alt Başlık Rengi",
    },
    iconColor: {
      key: "multipleBonusDialogIconColor",
      cssVar: "--multiple-bonus-dialog-icon-color",
      default: "#0ea5e9",
      label: "Hediye İkonu Rengi",
    },
    closeIconBgColor: {
      key: "multipleBonusDialogCloseIconBgColor",
      cssVar: "--multiple-bonus-dialog-close-icon-bg-color",
      default: "rgba(255, 255, 255, 0.07)",
      label: "Çarpı İkonu Arka Plan",
    },
    closeIconColor: {
      key: "multipleBonusDialogCloseIconColor",
      cssVar: "--multiple-bonus-dialog-close-icon-color",
      default: "rgba(255, 255, 255, 0.55)",
      label: "Çarpı İkonu Rengi",
    },
    optionButtonBgColor: {
      key: "multipleBonusDialogOptionButtonBgColor",
      cssVar: "--multiple-bonus-dialog-option-button-bg-color",
      default: "#0ea5e9",
      label: "Seçenek Buton Arka Plan",
    },
    optionButtonTextColor: {
      key: "multipleBonusDialogOptionButtonTextColor",
      cssVar: "--multiple-bonus-dialog-option-button-text-color",
      default: "#ffffff",
      label: "Seçenek Buton Yazı",
    },
    optionButtonHoverBgColor: {
      key: "multipleBonusDialogOptionButtonHoverBgColor",
      cssVar: "--multiple-bonus-dialog-option-button-hover-bg-color",
      default: "#38bdf8",
      label: "Seçenek Buton Hover",
    },
    optionButtonGlowColor: {
      key: "multipleBonusDialogOptionButtonGlowColor",
      cssVar: "--multiple-bonus-dialog-option-button-glow-color",
      default: "rgba(14, 165, 233, 0.40)",
      label: "Seçenek Buton Parıltı",
    },
    separatorTextColor: {
      key: "multipleBonusDialogSeparatorTextColor",
      cssVar: "--multiple-bonus-dialog-separator-text-color",
      default: "rgba(255, 255, 255, 0.45)",
      label: "Ayırıcı Yazı Rengi (veya)",
    },
    separatorLineColor: {
      key: "multipleBonusDialogSeparatorLineColor",
      cssVar: "--multiple-bonus-dialog-separator-line-color",
      default: "rgba(255, 255, 255, 0.10)",
      label: "Ayırıcı Çizgi Rengi",
    },
  },
  bonusConfirmPopup: {
    popupBgColor: {
      key: "bonusConfirmPopupBgColor",
      cssVar: "--bonus-confirm-popup-bg-color",
      default: "rgba(14, 165, 233, 0.08)",
      label: "Popup Arka Plan Rengi",
    },
    popupBorderColor: {
      key: "bonusConfirmPopupBorderColor",
      cssVar: "--bonus-confirm-popup-border-color",
      default: "rgba(14, 165, 233, 0.22)",
      label: "Popup Kenarlık Rengi",
    },
    titleColor: {
      key: "bonusConfirmPopupTitleColor",
      cssVar: "--bonus-confirm-popup-title-color",
      default: "#ffffff",
      label: "Bonus Başlık Rengi",
    },
    questionColor: {
      key: "bonusConfirmPopupQuestionColor",
      cssVar: "--bonus-confirm-popup-question-color",
      default: "rgba(255, 255, 255, 0.55)",
      label: "Soru Yazı Rengi",
    },
    imageBorderColor: {
      key: "bonusConfirmPopupImageBorderColor",
      cssVar: "--bonus-confirm-popup-image-border-color",
      default: "rgba(255, 255, 255, 0.10)",
      label: "Resim Kenarlık Rengi",
    },
    closeIconBgColor: {
      key: "bonusConfirmPopupCloseIconBgColor",
      cssVar: "--bonus-confirm-popup-close-icon-bg-color",
      default: "rgba(255, 255, 255, 0.07)",
      label: "Çarpı İkonu Arka Plan",
    },
    closeIconColor: {
      key: "bonusConfirmPopupCloseIconColor",
      cssVar: "--bonus-confirm-popup-close-icon-color",
      default: "rgba(255, 255, 255, 0.55)",
      label: "Çarpı İkonu Rengi",
    },
    rulesBtnBgColor: {
      key: "bonusConfirmPopupRulesBtnBgColor",
      cssVar: "--bonus-confirm-popup-rules-btn-bg-color",
      default: "rgba(14, 165, 233, 0.10)",
      label: "Bonus Kuralları Buton Arka Plan",
    },
    rulesBtnBorderColor: {
      key: "bonusConfirmPopupRulesBtnBorderColor",
      cssVar: "--bonus-confirm-popup-rules-btn-border-color",
      default: "rgba(14, 165, 233, 0.28)",
      label: "Bonus Kuralları Buton Kenarlık",
    },
    rulesBtnTextColor: {
      key: "bonusConfirmPopupRulesBtnTextColor",
      cssVar: "--bonus-confirm-popup-rules-btn-text-color",
      default: "#0ea5e9",
      label: "Bonus Kuralları Buton Yazı",
    },
    cancelButtonBgColor: {
      key: "bonusConfirmPopupCancelBgColor",
      cssVar: "--bonus-confirm-popup-cancel-bg-color",
      default: "rgba(255, 255, 255, 0.08)",
      label: "İptal Buton Arka Plan",
    },
    cancelButtonTextColor: {
      key: "bonusConfirmPopupCancelTextColor",
      cssVar: "--bonus-confirm-popup-cancel-text-color",
      default: "rgba(255, 255, 255, 0.80)",
      label: "İptal Buton Yazı Rengi",
    },
    confirmButtonBgColor: {
      key: "bonusConfirmPopupConfirmBgColor",
      cssVar: "--bonus-confirm-popup-confirm-bg-color",
      default: "#0ea5e9",
      label: "Onayla Buton Arka Plan",
    },
    confirmButtonTextColor: {
      key: "bonusConfirmPopupConfirmTextColor",
      cssVar: "--bonus-confirm-popup-confirm-text-color",
      default: "#ffffff",
      label: "Onayla Buton Yazı Rengi",
    },
  },
  loadingPage: {
    backgroundColor: {
      key: "loadingPageBgColor",
      cssVar: "--loading-page-bg-color",
      default: "linear-gradient(135deg, #060912 0%, #080d19 50%, #060912 100%)",
      label: "Arka Plan Rengi",
    },
    spinnerColor: {
      key: "loadingPageSpinnerColor",
      cssVar: "--loading-page-spinner-color",
      default: "#0ea5e9",
      label: "Loading Spinner Rengi",
    },
    textColor: {
      key: "loadingPageTextColor",
      cssVar: "--loading-page-text-color",
      default: "rgba(255, 255, 255, 0.40)",
      label: "Yazı Rengi",
    },
    spinnerSize: {
      type: "range",
      key: "loadingPageSpinnerSize",
      cssVar: "--loading-page-spinner-size",
      default: "56",
      label: "Spinner Boyutu",
      min: 20,
      max: 120,
      step: 5,
      unit: "px",
    },
  },
  appBackground: {
    primaryAura: {
      key: "appBgPrimaryAura",
      cssVar: "--app-bg-primary-aura",
      default: "rgba(14, 165, 233, 0.07)",
      label: "Birincil Aura Rengi",
    },
    accentAura: {
      key: "appBgAccentAura",
      cssVar: "--app-bg-accent-aura",
      default: "rgba(168, 85, 247, 0.05)",
      label: "Vurgu Aura Rengi",
    },
    bottomAura: {
      key: "appBgBottomAura",
      cssVar: "--app-bg-bottom-aura",
      default: "rgba(14, 165, 233, 0.04)",
      label: "Alt Aura Rengi",
    },
  },
  statusColors: {
    successColor: {
      key: "statusSuccessColor",
      cssVar: "--status-success-color",
      default: "#4ade80",
      label: "Başarılı (Onaylandı) Rengi",
    },
    errorColor: {
      key: "statusErrorColor",
      cssVar: "--status-error-color",
      default: "#f87171",
      label: "Hata (Reddedildi) Rengi",
    },
    warningColor: {
      key: "statusWarningColor",
      cssVar: "--status-warning-color",
      default: "#fbbf24",
      label: "Uyarı Rengi",
    },
    infoColor: {
      key: "statusInfoColor",
      cssVar: "--status-info-color",
      default: "#38bdf8",
      label: "Bilgi Rengi",
    },
  },
  alerts: {
    successColor: {
      key: "alertSuccessColor",
      cssVar: "--alert-success-color",
      default: "#2dbb54",
      label: "Başarılı Alert Rengi",
    },
    errorColor: {
      key: "alertErrorColor",
      cssVar: "--alert-error-color",
      default: "#ef4444",
      label: "Hata Alert Rengi",
    },
    warningColor: {
      key: "alertWarningColor",
      cssVar: "--alert-warning-color",
      default: "#f9a825",
      label: "Uyarı Alert Rengi",
    },
    infoColor: {
      key: "alertInfoColor",
      cssVar: "--alert-info-color",
      default: "#2d9bf0",
      label: "Bilgi Alert Rengi",
    },
  },
  badge: {
    bgColor: {
      key: "badgeBgColor",
      cssVar: "--badge-bg-color",
      default: "#ff4757",
      label: "Rozet Arka Plan",
    },
    textColor: {
      key: "badgeTextColor",
      cssVar: "--badge-text-color",
      default: "#ffffff",
      label: "Rozet Yazı Rengi",
    },
  },
  maintenance: {
    bgColor: {
      key: "maintenanceBgColor",
      cssVar: "--maintenance-bg-color",
      default: "#0E1F2C",
      label: "Arka Plan Rengi",
    },
    accentColor: {
      key: "maintenanceAccentColor",
      cssVar: "--maintenance-accent-color",
      default: "#e5b645",
      label: "Vurgu (İkon) Rengi",
    },
    textColor: {
      key: "maintenanceTextColor",
      cssVar: "--maintenance-text-color",
      default: "#e5b645",
      label: "Yazı Rengi",
    },
  },
  errorPage: {
    headingColor: {
      key: "errorPageHeadingColor",
      cssVar: "--error-page-heading-color",
      default: "#ff4757",
      label: "Hata Başlık Rengi",
    },
    textColor: {
      key: "errorPageTextColor",
      cssVar: "--error-page-text-color",
      default: "#666666",
      label: "Hata Açıklama Rengi",
    },
  },
};

// Tüm renk değerlerini düzleştir
const flattenThemeConfig = (config) => {
  const flattened = {};
  Object.keys(config).forEach((section) => {
    Object.keys(config[section]).forEach((property) => {
      const key = `${section}_${property}`;
      flattened[key] = config[section][property];
    });
  });
  return flattened;
};

const FLAT_CONFIG = flattenThemeConfig(THEME_CONFIG);

// Tema yönetimi hook'u
export const useThemeManager = () => {
  const [isLoadingFromApi, setIsLoadingFromApi] = useState(true);

  const [themeValues, setThemeValues] = useState(() => {
    const initialValues = {};
    Object.keys(FLAT_CONFIG).forEach((key) => {
      const configItem = FLAT_CONFIG[key];
      let value = configItem.default;

      if (configItem.unit && configItem.default && !String(configItem.default).includes(configItem.unit)) {
        value = `${configItem.default}${configItem.unit}`;
      }

      initialValues[key] = value;
    });
    return initialValues;
  });

  const updateCSSVariable = useCallback((cssVar, value) => {
    const stringValue = String(value);
    if (stringValue === "" || value === null || value === undefined) {
      document.documentElement.style.removeProperty(cssVar);
    } else {
      document.documentElement.style.setProperty(cssVar, stringValue);
    }
  }, []);

  const loadFromLocalStorage = useCallback(() => {
    const values = {};
    Object.keys(FLAT_CONFIG).forEach((key) => {
      const configItem = FLAT_CONFIG[key];
      const savedValue = localStorage.getItem(configItem.key);
      let value = savedValue || configItem.default;

      if (configItem.unit && !savedValue && configItem.default && !String(configItem.default).includes(configItem.unit)) {
        value = `${configItem.default}${configItem.unit}`;
      }

      values[key] = value;
      updateCSSVariable(configItem.cssVar, value);
    });
    setThemeValues(values);
  }, [updateCSSVariable]);

  const loadCssFromApi = useCallback(async () => {
    try {
      if (!window.rh || !window.rh.cr) {
        loadFromLocalStorage();
        setIsLoadingFromApi(false);
        return;
      }

      const payload = JSON.stringify({
        process_id: "get-css",
        user_id: "",
      });

      const keys = await window.rh.cr(payload);

      const response = await fetch(
        `${config.apiBaseUrl}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "hk": keys[0],
            "hh": keys[1]
          },
          body: payload,
        }
      );

      if (!response.ok) {
        loadFromLocalStorage();
        setIsLoadingFromApi(false);
        return;
      }

      const result = await response.json();

      let cssData = result;

      if (result.status && result.data) {
        cssData = result.data;
      } else if (result.status === false) {
        loadFromLocalStorage();
        setIsLoadingFromApi(false);
        return;
      }

      if (cssData && typeof cssData === 'object') {
        const newThemeValues = {};
        Object.keys(FLAT_CONFIG).forEach((key) => {
          const configItem = FLAT_CONFIG[key];
          const apiValue = cssData[configItem.cssVar];

          if (apiValue !== undefined && apiValue !== null && apiValue !== '') {
            newThemeValues[key] = apiValue;
            localStorage.setItem(configItem.key, apiValue);
            updateCSSVariable(configItem.cssVar, apiValue);
          } else {
            const savedValue = localStorage.getItem(configItem.key);
            let value = savedValue || configItem.default;

            if (configItem.unit && !savedValue && configItem.default && !String(configItem.default).includes(configItem.unit)) {
              value = `${configItem.default}${configItem.unit}`;
            }

            newThemeValues[key] = value;
            updateCSSVariable(configItem.cssVar, value);
          }
        });

        setThemeValues(newThemeValues);
      } else {
        loadFromLocalStorage();
      }
    } catch (error) {
      loadFromLocalStorage();
    } finally {
      setIsLoadingFromApi(false);
    }
  }, [loadFromLocalStorage, updateCSSVariable]);

  useEffect(() => {
    loadCssFromApi();
  }, [loadCssFromApi]);

  const updateLocalStorage = useCallback((key, value) => {
    localStorage.setItem(key, value);
  }, []);

  const updateThemeValue = useCallback(
    (key, value) => {
      const configItem = FLAT_CONFIG[key];
      if (!configItem) return;

      setThemeValues((prev) => ({ ...prev, [key]: value }));
      updateCSSVariable(configItem.cssVar, value);
      updateLocalStorage(configItem.key, value);
    },
    [updateCSSVariable, updateLocalStorage]
  );

  const resetToDefaults = useCallback(() => {
    Object.keys(FLAT_CONFIG).forEach((key) => {
      const config = FLAT_CONFIG[key];
      let defaultValue = config.default;

      if (config.unit && defaultValue && !String(defaultValue).includes(config.unit)) {
        defaultValue = `${defaultValue}${config.unit}`;
      }

      setThemeValues((prev) => ({ ...prev, [key]: defaultValue }));
      updateCSSVariable(config.cssVar, defaultValue);
      localStorage.removeItem(config.key);
    });
  }, [updateCSSVariable]);

  useEffect(() => {
    if (!isLoadingFromApi) {
      Object.keys(FLAT_CONFIG).forEach((key) => {
        const configItem = FLAT_CONFIG[key];
        let value = themeValues[key];

        if (configItem.unit && value === configItem.default && !String(value).includes(configItem.unit)) {
          value = `${value}${configItem.unit}`;
        }

        updateCSSVariable(configItem.cssVar, value);
      });
    }
  }, [themeValues, updateCSSVariable, isLoadingFromApi]);

  return {
    themeValues,
    themeConfig: THEME_CONFIG,
    flatConfig: FLAT_CONFIG,
    updateThemeValue,
    resetToDefaults,
  };
};
